import { useState, useEffect, useCallback } from "react";
import { Box, FormControl, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import Yup from "validation/Validation";
import { Alert, Pane, Spinner } from "evergreen-ui";
import { useParams } from "react-router-dom";
import {
  useAddProductsMutation,
  useCheckExistsMutation,
  useGetArticlesQuery,
  useGetCategoriesQuery,
  useSingleProductMutation,
  useUpdateProductMutation,
} from "redux/api/slices/server";
import PageTitle from "./PageTitle";
import AlertsCards from "./AlertsCards";
import ProductForm from "./ProductForm";
import FormBottom from "./FormBottom";
import ProductImages from "./ProductImages";

const DetailProductPage = () => {
  const { id, queryCategory } = useParams();
  const [urunKategori, setUrunKategori] = useState(0);
  const [urunArticle, setArticle] = useState(0);
  const [content, setContent] = useState("");

  const handleOnChange = (e) => {
    setUrunKategori(e.target.value);
  };

  const initVal = {
    title: "",
    alttag: "",
    page_title: "",
    page_description: "",
    page_keywords: "",
  };

  const [initialValues, setInitialValues] = useState(initVal);
  const [images, setImages] = useState([]);
  const [newImageId, setnewImageId] = useState(-100);
  const [imagesState, setImagesState] = useState([]);

  const onChangeImages = (imageList, addUpdateIndex) => {
    let currentNewImageId = newImageId;
    imageList.forEach((element) => {
      if (isNaN(element.id) || element.id === 0) {
        element.id = currentNewImageId;
        element.deleted = false;
        currentNewImageId--;
      }
    });
    setnewImageId(currentNewImageId);
    setImages(imageList);

    let tmpImageState = imagesState;
    //YENI EKLENEN RESIMLERI imagesState'E EKLE
    const newImageList = imageList.filter(
      (newImage) => !imagesState.some((image) => image.id === newImage.id)
    );
    tmpImageState = [...tmpImageState, ...newImageList];
    //SILINEN RESIMLERI imagesState'DE deleted olarak isaretle
    tmpImageState.forEach((imgState) => {
      let bulundu = false;
      imageList.forEach((img) => {
        if (img.id === imgState.id) bulundu = true;
      });
      if (!bulundu) {
        //Arrayden cikarma! Varolan resimler arrayden cikarsa sunucuda sildigini nasil bilecek?
        imgState.deleted = true;
        imgState.data_url = "";
      }
    });
    setImagesState(tmpImageState);
  };

  const handleSelectCoverImage = (selectedIndex) => {
    if (selectedIndex !== -1) {
      let selectedId = 0;
      const updatedImages = images.map((image, index) => {
        if (index === selectedIndex) {
          selectedId = image.id;
          return { ...image, cover: true };
        }
        return { ...image, cover: false };
      });
      setImages(updatedImages);
      if (selectedId !== 0) {
        const updatedImageStates = imagesState.map((image, index) => {
          if (image.id === selectedId) {
            return { ...image, cover: true };
          }
          return { ...image, cover: false };
        });
        setImagesState(updatedImageStates);
      }
    }
  };

  const categories = useGetCategoriesQuery();
  const articles = useGetArticlesQuery();
  const [addProducts, addData] = useAddProductsMutation();
  const [singleProduct, singleData] = useSingleProductMutation();
  const [updateProduct, updateData] = useUpdateProductMutation();

  const formFields = {
    title: Yup.string().required(),
    alttag: Yup.string(),
    page_title: Yup.string().max(70, "Karakter Sayısını Aştınız"),
    page_description: Yup.string().max(160, "Karakter Sayısını Aştınız"),
    page_keywords: Yup.string(),
    category: Yup.number(),
    article: Yup.number(),
  };

  const validationSchema = Yup.object(formFields);

  const [producTitle, setProductTitle] = useState("");

  const replaceTitle = useCallback((content, value) => {
    return content.replace(/\(\(.*?\)\)/g, `((${value}))`);
  }, []);

  const setUrunArticle = useCallback(
    (id, e) => {
      const art = articles.data?.find((item) => item.id === id);
      setArticle(id);
      setContent(replaceTitle(art?.content, producTitle));
    },
    [articles, producTitle, replaceTitle]
  );

  const handleChangeEditor = (value) => {
    const updatedContent = replaceTitle(value, producTitle);
    setContent(updatedContent);
  };

  const [checkExists, check] = useCheckExistsMutation();

  const combinedHandleChange = (event) => {
    handleChange(event);
    setProductTitle(event.target.value);
    setContent(replaceTitle(content, event.target.value));
    checkExists({ title: event.target.value });
  };

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit: (values) => {
      const productObject = {
        title: values.title,
        content: content,
        article: parseInt(urunArticle),
        category: urunKategori,
        alttag: values.alttag,
        page_title: values.page_title,
        page_description: values.page_description,
        page_keywords: values.page_keywords,
        image: imagesState,
      };

      if (id > 0) {
        updateProduct(Object.assign(productObject, { id: parseInt(id) }));
        setInitialValues(productObject);
      } else {
        addProducts(productObject);
        if (addData.data) {
          if (addData.data.status === "success") {
            setInitialValues(initVal);
            setContent("");
            setUrunKategori(0);
            setArticle(0);
          }
        }
      }
    },
  });

  useEffect(() => {
    singleProduct({ id, queryCategory });
  }, [id, queryCategory, singleProduct]);

  useEffect(() => {
    if (id > 0) {
      if (singleData.isSuccess) {
        setUrunKategori(singleData.data.product.katid);
        setArticle(singleData.data.product.articleId);
        setContent(
          replaceTitle(
            singleData.data.product.tr_aciklama,
            singleData.data.product.tr_baslik
          )
        );

        if (singleData.data.uploadedImage) {
          setImages(singleData.data.uploadedImage);
          const imagesStateArray = singleData.data.uploadedImage.map(
            (row, i) => {
              return {
                id: row.id,
                data_url: "",
                deleted: false,
              };
            }
          );
          setImagesState(imagesStateArray);
        }

        setProductTitle(singleData.data.product.tr_baslik);
        setInitialValues({
          title: singleData.data.product.tr_baslik,
          alttag: singleData.data.product.alttag,
          page_title: singleData.data.product.baslik,
          page_description: singleData.data.product.aciklama,
          page_keywords: singleData.data.product.anahtar,
        });
      }
    }
  }, [id, singleData, replaceTitle]);

  if (addData.isLoading || singleData.isLoading || updateData.isLoading) {
    return (
      <div className="w-full flex justify-center items-center">
        <Pane>
          <Spinner marginX="auto" size={60} marginTop={25} marginBottom={50} />
          <Typography variant="h5" gutterBottom>
            İşlem Yapılıyor. Lütfen Bekleyniz...
          </Typography>
        </Pane>
      </div>
    );
  }

  return (
    <div className="w-full my-6">
      <div className="w-full h-auto container mx-auto">
        <PageTitle id={id} singleData={singleData} />
        <div className="w-full h-auto flex flex-col p-5 gap-4 border shadow bg-white">
          <AlertsCards
            id={id}
            initialValues={initialValues}
            addData={addData}
            updateData={updateData}
            singleData={singleData}
          />
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 1 }}
            autoComplete="on"
          >
            {!addData.isSuccess && check.data && (
              <Alert
                intent="danger"
                marginBottom={15}
                title="Bu isim daha önce kullanıldı"
              />
            )}
            <ProductForm
              initialValues={initialValues}
              urunKategori={urunKategori}
              setUrunKategori={handleOnChange}
              urunArticle={urunArticle}
              setUrunArticle={setUrunArticle}
              values={values}
              errors={errors}
              categories={categories}
              articles={articles}
              handleChangeEditor={handleChangeEditor}
              content={content}
              combinedHandleChange={combinedHandleChange}
            />
            <ProductImages
              images={images}
              onChangeImages={onChangeImages}
              handleSelectCoverImage={handleSelectCoverImage}
            />
            <div className="w-full flex items-center gap-5 my-4">
              <FormControl fullWidth>
                <div className="flex items-center">
                  <TextField
                    sx={{ m: 0 }}
                    size="small"
                    margin="normal"
                    fullWidth
                    id="page_title"
                    label="Sayfa Başlık (TITLE)"
                    name="page_title"
                    autoComplete="page_title"
                    onChange={handleChange}
                    defaultValue={initialValues.page_title}
                    key={initialValues.page_title}
                    values={values.page_title}
                    helperText={errors.page_title && errors.page_title}
                    error={errors.page_title ? true : false}
                  />
                  <div className="px-4 py-2 font-semibold text-black bg-gray-300">
                    {values.page_title.length}
                  </div>
                </div>
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  sx={{ m: 0 }}
                  size="small"
                  margin="normal"
                  fullWidth
                  id="page_keywords"
                  label="Sayfa Anahtar Kelimeleri (KEYWORDS)"
                  name="page_keywords"
                  autoComplete="page_keywords"
                  onChange={handleChange}
                  defaultValue={initialValues.page_keywords}
                  key={initialValues.page_keywords}
                  values={values.page_keywords}
                  helperText={errors.page_keywords && errors.page_keywords}
                  error={errors.page_keywords ? true : false}
                />
              </FormControl>
            </div>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <div className="flex items-center">
                <TextField
                  sx={{ m: 0 }}
                  multiline
                  rows={2}
                  size="small"
                  margin="normal"
                  fullWidth
                  id="page_description"
                  label="Sayfa Açıklaması (DESCRİPTİON)"
                  name="page_description"
                  autoComplete="page_description"
                  onChange={handleChange}
                  defaultValue={initialValues.page_description}
                  key={initialValues.page_description}
                  values={values.page_description}
                  helperText={
                    errors.page_description && errors.page_description
                  }
                  error={errors.page_description ? true : false}
                />
                <div className="px-4 py-2 font-semibold text-black bg-gray-300">
                  {values.page_description.length}
                </div>
              </div>
            </FormControl>
            <FormControl fullWidth>
              <TextField
                sx={{ m: 0 }}
                size="small"
                margin="normal"
                fullWidth
                id="alttag"
                label="Resim Alt Tag"
                name="alttag"
                autoComplete="alttag"
                onChange={handleChange}
                defaultValue={initialValues.alttag}
                key={initialValues.alttag}
                values={values.alttag}
                helperText={errors.alttag && errors.alttag}
                error={errors.alttag ? true : false}
              />
            </FormControl>
            <FormBottom backLink={singleData.data?.parentCategory?.id} />
          </Box>
        </div>
      </div>
    </div>
  );
};

export default DetailProductPage;
